(() => {
  'use strict';
  const root = document.querySelector('[data-decoration-sets]');
  if (!root) return;

  function init() {
    if (root.dataset.galleryBound) return;
    root.dataset.galleryBound = 'true';
    const q = selector => root.querySelector(selector);
    const read = selector => JSON.parse(q(selector).textContent);
    const galleries = read('[data-set-gallery]');
    const sets = read('[data-set-manifest]');
    const copies = read('[data-gallery-copy]');
    const assets = read('[data-set-assets]');
    const thumbs = read('[data-gallery-thumbs]');
    const copy = copies[root.dataset.language] || copies.en;
    const rail = q('[data-gallery-rail]');
    const viewer = q('[data-gallery-viewer]');
    const image = q('[data-set-hero]');
    let current = [], selected = 0;
    let preferred = new URLSearchParams(location.search).get('image') || 'tree';
    const label = (selector, value) => { q(selector).textContent = value; };
    const available = entry => Boolean(entry && entry.asset && assets[entry.asset]);
    const title = entry => root.dataset.language === 'zh' && entry.titleZh ? entry.titleZh : entry.title;

    rail.setAttribute('aria-label', copy.gallery);
    for (const [selector, key] of [
      ['[data-gallery-zoom]', 'enlarge'], ['[data-gallery-close]', 'close'],
      ['[data-gallery-prev]', 'previous'], ['[data-gallery-next]', 'next'],
      ['[data-gallery-original]', 'original']
    ]) label(selector, copy[key]);
    label('[data-gallery-size]', '100%');

    function select(index, saveUrl = true) {
      if (!current.length) return;
      let target = (index + current.length) % current.length;
      if (!available(current[target])) target = current.findIndex(available);
      if (target < 0) return;
      selected = target;
      const entry = current[selected];
      preferred = entry.kind;
      const name = title(entry);
      image.src = assets[entry.asset];
      if (entry.width) image.width = entry.width;
      if (entry.height) image.height = entry.height;
      image.alt = name + ' | ' + copy[entry.kind];
      q('[data-hero-link]').href = assets[entry.asset];
      q('[data-tree-note]').textContent = copy[entry.kind + 'Note'];
      root.dataset.galleryKind = entry.kind;
      [...rail.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
      label('[data-gallery-title]', name + ' | ' + copy[entry.kind]);
      q('[data-gallery-viewer-image]').src = assets[entry.asset];
      q('[data-gallery-viewer-image]').alt = image.alt;
      q('[data-gallery-original]').href = assets[entry.asset];
      viewer.dataset.zoomed = 'false';
      q('[data-gallery-size]').setAttribute('aria-pressed', 'false');
      label('[data-gallery-size]', '100%');
      if (saveUrl) {
        const url = new URL(location.href);
        if (entry.kind === 'tree') url.searchParams.delete('image');
        else url.searchParams.set('image', entry.kind);
        history.replaceState(null, '', url);
      }
    }

    function move(direction) {
      for (let step = 1; step <= current.length; step++) {
        const index = (selected + direction * step + current.length * 2) % current.length;
        if (available(current[index])) { select(index); return; }
      }
    }

    function update() {
      const gallery = galleries.find(item => item.code === root.dataset.selected);
      const set = sets.find(item => item.code === root.dataset.selected);
      if (!gallery || !set) return;
      current = gallery.images;
      rail.replaceChildren();
      current.forEach((entry, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.galleryIndex = String(index);
        button.dataset.imageKind = entry.kind;
        button.setAttribute('aria-pressed', 'false');
        if (available(entry)) {
          const thumb = document.createElement('img');
          thumb.src = thumbs[entry.asset] || assets[entry.asset];
          thumb.alt = '';
          thumb.width = 96;
          thumb.height = 96;
          thumb.decoding = 'async';
          button.append(thumb);
          button.addEventListener('click', () => select(index));
        } else {
          button.disabled = true;
          button.classList.add('qs-gallery-pending');
        }
        const caption = document.createElement('span');
        caption.textContent = copy[entry.kind] + (available(entry) ? '' : ' · ' + copy.pending);
        button.append(caption);
        rail.append(button);
      });
      const sourcePhotos = [...new Map(set.components.filter(c => c.image && assets[c.image]).map(c => [c.image, c])).values()];
      label('[data-source-title]', copy.sourceTitle);
      label('[data-source-more]', copy.sourceMore);
      const sourceList = q('[data-source-mini]');
      sourceList.replaceChildren();
      sourcePhotos.slice(0, 6).forEach(component => {
        const anchor = document.createElement('a');
        anchor.href = assets[component.image];
        anchor.target = '_blank';
        anchor.rel = 'noopener';
        const productName = root.dataset.language === 'zh' && component.nameZh ? component.nameZh : component.name;
        anchor.title = component.code + ' · ' + productName + (component.sourceScope === 'family_representative' ? ' · ' + copy.familyPhoto : '');
        const photo = document.createElement('img');
        photo.src = thumbs[component.image] || assets[component.image];
        photo.alt = anchor.title;
        photo.width = 88;
        photo.height = 88;
        photo.loading = 'lazy';
        anchor.append(photo);
        sourceList.append(anchor);
      });
      q('[data-source-more]').hidden = sourcePhotos.length <= 6;
      const preferredIndex = current.findIndex(entry => entry.kind === preferred && available(entry));
      select(preferredIndex < 0 ? current.findIndex(available) : preferredIndex, false);
    }

    const open = () => { if (!viewer.open && current.some(available)) viewer.showModal(); };
    q('[data-hero-link]').addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      open();
    });
    q('[data-gallery-zoom]').addEventListener('click', open);
    q('[data-gallery-close]').addEventListener('click', () => viewer.close());
    viewer.addEventListener('click', event => { if (event.target === viewer) viewer.close(); });
    q('[data-gallery-prev]').addEventListener('click', () => move(-1));
    q('[data-gallery-next]').addEventListener('click', () => move(1));
    viewer.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
    });
    q('[data-gallery-size]').addEventListener('click', () => {
      const zoom = viewer.dataset.zoomed !== 'true';
      viewer.dataset.zoomed = String(zoom);
      q('[data-gallery-size]').setAttribute('aria-pressed', String(zoom));
      label('[data-gallery-size]', zoom ? copy.fit : '100%');
    });
    new MutationObserver(update).observe(root, { attributes: true, attributeFilter: ['data-selected'] });
    update();
    document.querySelector('[data-language-picker]')?.addEventListener('change', () => {
      const option = document.querySelector('[data-language-picker]').selectedOptions[0];
      if (option && preferred !== 'tree') {
        const url = new URL(option.value, location.origin);
        url.searchParams.set('image', preferred);
        option.value = url.pathname + url.search;
      }
    }, true);
  }

  if (root.dataset.bound === 'true') init();
  else {
    const observer = new MutationObserver(() => {
      if (root.dataset.bound === 'true') { observer.disconnect(); init(); }
    });
    observer.observe(root, { attributes: true, attributeFilter: ['data-bound'] });
  }
})();
